import React from 'react'
import {
  TextField
} from '@material-ui/core';

const ConditionFormula = ({conditionFormula, handleChange}) => {
  return (
    <TextField  label="Condition Formula"
      variant="outlined"                            
      fullWidth
      name='condition_formula'
      margin={'normal'}
      value={conditionFormula}
      onChange={({target}) => handleChange(target)}
      inputProps={{
        autoComplete: 'on',
      }}
      type="text" />
  )
}

export default ConditionFormula
